import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg className={(styles["codicon"] || "codicon") + " " + (styles["codicon-flame"] || "codicon-flame")} viewBox="0 0 22 28" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="none" fillRule="evenodd"><path d="M10.705 25.74C-1.167 23.522.299 16.31 5.528 9.16c.82 8.471 8.693 4.144 5.177-5.419 10.255 7.454 14.747 18.697 0 22zM10.704 25.733c-7.432-7.48 11.769-8.656 4.76-17.811" /></g></svg>;